<div class="left-sidebar-content">
  @if (isSidebarHidden()) {
    <mat-icon svgIcon="collapsed-tim" [attr.data-testid]="testIds.sidebarHeaderIcon"></mat-icon>
  } @else {
    <mat-icon class="tim-orgadmin-logo" [attr.data-testid]="testIds.adminsidebarHeaderIcon" svgIcon="tim-orgadmin-logo">
    </mat-icon>
  }
  <hr />
  @for (domainDto of domain$ | async; track $index) {
    <app-dropdown
      class="org-admin"
      [label]="domainDto.domain"
      [collapsed]="isSidebarHidden()"
      [orgAdmin]="true"
      [dataTestId]="testIds.dropdownDomainPrefix + $index">
      <mat-nav-list
        [attr.data-testid]="testIds.listContainer"
        class="tab-wrapper"
        [ngClass]="isSidebarHidden() ? 'collapsed' : ''">
        <mat-list-item
          [attr.data-testid]="testIds.listGeneralUsers + $index"
          routerLinkActive="active"
          class="sidebar-tab"
          [ngClass]="isSidebarHidden() ? 'collapsed' : ''"
          routerLink="{{ domainDto.domain }}/general-users">
          @if (isSidebarHidden()) {
            <mat-icon
              matListItemIcon
              svgIcon="users-org"
              class="user sidebar-icon"
              matTooltip="Nutzerverwaltung"
              matTooltipPosition="right"></mat-icon>
          } @else {
            <div class="item-wrapper">
              <p>Nutzerverwaltung</p>
              <app-counter-badge class="sidebar-counter"></app-counter-badge>
            </div>
          }
        </mat-list-item>
        <mat-list-item
          [attr.data-testid]="testIds.listItemReportsPrefix + $index"
          class="sidebar-tab"
          [ngClass]="isSidebarHidden() ? 'collapsed' : ''"
          routerLinkActive="active"
          routerLink="{{ domainDto.domain }}/reports">
          @if (isSidebarHidden()) {
            <mat-icon
              matListItemIcon
              svgIcon="reported"
              class="report sidebar-icon"
              matTooltip="Gemeldete Inhalte"
              matTooltipPosition="right"></mat-icon>
          } @else {
            <div class="item-wrapper">
              <p>Gemeldete Inhalte</p>
              <app-counter-badge class="sidebar-counter"></app-counter-badge>
            </div>
          }
        </mat-list-item>
        <mat-list-item
          [attr.data-testid]="testIds.listItemHealthcarePrefix + $index"
          class="sidebar-tab"
          [ngClass]="isSidebarHidden() ? 'collapsed' : ''"
          routerLinkActive="active"
          routerLink="{{ domainDto.domain }}/healthcare">
          @if (isSidebarHidden()) {
            <mat-icon
              matListItemIcon
              svgIcon="heart"
              class="health sidebar-icon"
              matTooltip="Healthcare Service-Verwaltung"
              matTooltipPosition="right"></mat-icon>
          } @else {
            <div class="item-wrapper">
              <p>Healthcare Service-Verwaltung</p>
              <app-counter-badge class="sidebar-counter"></app-counter-badge>
            </div>
          }
        </mat-list-item>
        <mat-list-item
          [attr.data-testid]="testIds.listItemServerconfigPrefix + $index"
          class="sidebar-tab"
          [ngClass]="isSidebarHidden() ? 'collapsed' : ''"
          routerLinkActive="active"
          routerLink="{{ domainDto.domain }}/serverconfig">
          @if (isSidebarHidden()) {
            <mat-icon
              matListItemIcon
              svgIcon="server"
              class="serverconfig sidebar-icon"
              matTooltip="Serverkonfiguration"
              matTooltipPosition="right"></mat-icon>
          } @else {
            <div class="item-wrapper"><p>Serverkonfiguration</p></div>
          }
        </mat-list-item>
      </mat-nav-list>
    </app-dropdown>
    <hr />
  }

  <div class="sidenav_bottom">
    <hr [class.collapsed]="isSidebarHidden()" />
    <div class="bottom-buttons">
      <app-button
        (clicked)="logout()"
        [collapsed]="isOpen"
        [dataTestId]="testIds.buttonLogout"
        [isPrimary]="true"
        text="Log out">
        <mat-icon svgIcon="logout-icon"></mat-icon>
        @if (!isSidebarHidden()) {
          Log out
        }
      </app-button>
    </div>
  </div>

  <div [class.collapsed]="isSidebarHidden()" class="sidebar-footer" [attr.data-testid]="testIds.sidebarFooter">
    <p class="version-info">
      @if (!isSidebarHidden()) {
        <span class="footer-text" [style.width]="'auto'" [style.display]="'inline-block'">
          {{ environment.timClientVersion }}
        </span>
      }
      <button
        (click)="toggleSidebar()"
        [class.collapsed]="isSidebarHidden()"
        [style.float]="isSidebarHidden() ? 'left' : 'right'"
        class="toggle-sidebar-button"
        [attr.data-testid]="testIds.buttonToggleSideNav">
        @if (isSidebarHidden()) {
          <mat-icon svgIcon="double-arrow-left" [class.rotated]="isSidebarHidden()"> ></mat-icon>
        }
        @if (!isSidebarHidden()) {
          <mat-icon svgIcon="double-arrow-left"></mat-icon>
        }
      </button>
    </p>
  </div>
</div>
